import { Observable } from "rxjs/internal/Observable";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpService } from "../services/http.service";
import { User } from "./models/user.model";
import { AdminUser } from "./models/admin_user.model";
import { Admin } from "./models/admin.model";
import { Category } from "./models/category.model";
import { NotificationModel } from "./models/notification.model";
import { map, tap } from "rxjs";
import { DataUser, Establishment } from "./models/data.user";
import { AuthService } from "./auth.service";

@Injectable({
	providedIn: "root",
})
export class AdminService {
	constructor(protected http: HttpService) {}

	public users(userType?: number): Observable<DataUser[]> {
		return this.http
			.get(
				environment.api.users,
				userType
					? {
							type: userType,
					  }
					: null
			)
			.pipe(
				map((users: DataUser[]) => {
					return users;
				})
			);
	}

	public adminUsers(): Observable<AdminUser[]> {
		return this.http.get(environment.api.admins);
	}

	public getNotifications(): Observable<NotificationModel[]> {
		return this.http.get(environment.api.notification);
	}

	public sendNotification(
		data: NotificationModel,
		users: DataUser[],
		all: boolean,
		type: number
	): Observable<any> {
		return this.http.post(environment.api.notification, {
			notification: data,
			users: all ? null : users.map((a) => a.email),
			all: all,
			type: type,
		});
	}

	public setNotificationStatus(
		notification: NotificationModel
	): Observable<any> {
		return this.http.put(environment.api.handleNotification, notification);
	}

	public deleteNotification(notification_id: number): Observable<any> {
		return this.http.delete(environment.api.deleteNotification, {
			notification_id: notification_id,
		});
	}

	public storeToken(token: any): Observable<any> {
		return this.http.post(environment.api.storeToken, token);
	}

	public registerUser(user: any): Observable<DataUser> {
		return this.http.post(environment.api.user, user);
	}

	public updateUser(user: any): Observable<DataUser> {
		return this.http.put(environment.api.user, user);
	}
	public updateUserStatus(status: number, id: number): Observable<any> {
		return this.http.put(
			`${environment.api.user}/${environment.api.updateStatus}`,
			{ status: status, id: id }
		);
	}

	public updateAdminUser(adminUser: AdminUser): Observable<any> {
		return this.http.put(environment.api.admin, adminUser);
	}

	public registerAdminUser(adminUser: AdminUser): Observable<AdminUser> {
		return this.http.post(environment.api.admin, adminUser);
	}
	
	public deleteAdminUser(adminUser: Admin): Observable<any> {
		return this.http.delete(environment.api.admin, adminUser);
	}

	public getUserData(): Observable<any> {
		return this.http.get(environment.api.getUserData);
	}
}
